// region Imports
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { I18n } from "react-redux-i18n";
import Layout from "../../../Layouts/LayoutMain";
import Wizard from "../../../Components/Wizard/Wizard";
import CheckoutSummary from "../CheckoutSummary";
import CreateAccountForm from "../../../Components/Checkout/Forms/CreateAccountForm";
import { setGuestAlertStauts } from "../../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../../Store/Status/Actions";
import {
    getCountries,
    getStates,
    getAddresses,
    getCustomerPaymentMethods,
    getPaymentMethods,
    processLease
} from "../../../Store/Checkout/Actions";
import { PageTitle } from "../../../Components/Common/PageTitle";
import BillingAddressForm from "../../../Components/Checkout/Forms/BillingAddressForm";
import ShippingAddressForm from "../../../Components/Checkout/Forms/ShippingAddressForm";
import ShippingMethodForm from "../../../Components/Checkout/Forms/ShippingMethodForm";
import PaymentMethodForm from "../../../Components/Checkout/Forms/PaymentMethodForm";
import Constants from "../../../AppConstants/Constants";
// endregion

class ProcessLease extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedBillingAddressId: null,
            selectedShippingAddressId: null,
            isGuest: false
        };

        this.onBillingAddressChange = this.onBillingAddressChange.bind(this);
        this.onShippingAddressChange = this.onShippingAddressChange.bind(this);
        this.onSubmitFinished = this.onSubmitFinished.bind(this);
    }

    componentWillMount() {
        const { userInfo, history, getCountries, getStates, getAddresses, getCustomerPaymentMethods, getPaymentMethods, setGuestAlertStauts, currentApprovalCode, countries, states } = this.props;

        if (!currentApprovalCode.approvalCode) {
            history.push(Constants.ENDPOINTS.CART);
        } else {
            setGuestAlertStauts(false);

            if (!countries || countries.length === 0) {
                getCountries(countries => {
                    if (!states || states.length === 0) {
                        getStates(countries[0].countryId);
                    }
                });
            }

            if (!userInfo.isGuest) {
                getCustomerPaymentMethods();
                getAddresses();
            } else {
                this.setState({ isGuest: true });
            }

            getPaymentMethods();
        }
    }

    componentWillUnmount() {
        const { setGuestAlertStauts } = this.props;

        setGuestAlertStauts(true);
    }

    onBillingAddressChange(selectedBillingAddressId) {
        this.setState({ selectedBillingAddressId });
    }

    onShippingAddressChange(selectedShippingAddressId) {
        this.setState({ selectedShippingAddressId });
    }

    onSubmitFinished(response) {
        const { history, toggleBlockingStatus } = this.props;

        toggleBlockingStatus(false);

        history.push(Constants.ENDPOINTS.ORDER_CONFIRMATION);
    }

    render() {
        const { processLease, orderSummary, config: { LEASE_RATE } } = this.props;
        const { isGuest, selectedBillingAddressId, selectedShippingAddressId } = this.state;
        let shippingOption = `${I18n.t("misc.shipping")} (US):`;
        let subTotal = 0;
        let taxRate = 0;
        let taxes = 0;
        let shipping = 0;
        let total = 0;
        let recurringTotal = 0;
        let productNeedsAgreement = false;
        let rentalNeedsAgreement = false;

        if (orderSummary && orderSummary.items) {
            if (orderSummary.taxRates && orderSummary.taxRates[0] && parseFloat(orderSummary.taxRates[0].rate) > 0) {
                taxRate = parseFloat(orderSummary.taxRates[0].rate) / 100;
            }

            if (orderSummary.selectedShippingMethod) {
                shippingOption = `Estimated Shipping (${orderSummary.selectedShippingMethod}):`;
                shipping = orderSummary.shippingValue;
            }

            _.each(orderSummary.items, item => {
                if (item.productNeedsAgreement) {
                    productNeedsAgreement = true;
                }
                if (item.rentalNeedsAgreement) {
                    rentalNeedsAgreement = true;
                }
                if (!item.isRecurring) {
                    subTotal += item.subTotalValue;
                } else {
                    recurringTotal += item.subTotalValue;
                }
            });

            taxes = (subTotal + shipping) * taxRate;
            total = subTotal + shipping + taxes;
        }

        const steps = [
            { name: "checkout.wizard.steps.one.title", component: <BillingAddressForm
                onAddressChange={this.onBillingAddressChange}
                selectedAddressId={selectedBillingAddressId}
                wizardName="Lease"
            /> },
            { name: "checkout.wizard.steps.two.title", component: <ShippingAddressForm
                onAddressChange={this.onShippingAddressChange}
                selectedAddressId={selectedShippingAddressId}
                wizardName="Lease"
            /> },
            { name: "checkout.wizard.steps.three.title", component: <ShippingMethodForm wizardName="Lease" /> },
            { name: "checkout.wizard.steps.four.title", component: <PaymentMethodForm wizardName="Lease" productNeedsAgreement={productNeedsAgreement} rentalNeedsAgreement={ rentalNeedsAgreement }/> }
        ];

        // eslint-disable-next-line no-undef
        const leaseAmount = total * LEASE_RATE;

        if (isGuest) {
            steps.unshift({ name: I18n.t("checkout.wizard.steps.zero.title"), component: <CreateAccountForm wizardName="Lease" /> });
        }

        return (
            <Layout isAuthenticated={this.props.isAuthenticated}>
                <PageTitle title="checkout.title" />
                <CheckoutSummary
                    subTotal={subTotal}
                    shippingOption={shippingOption}
                    shipping={shipping}
                    taxes={taxes}
                    total={total}
                    recurringTotal={recurringTotal}
                    leaseAmount={leaseAmount}
                />
                <Wizard
                    name="Lease"
                    submitAction={processLease}
                    steps={steps}
                    onFinished={this.onSubmitFinished}
                />
            </Layout>
        );
    }
}

ProcessLease.propTypes = {
    setGuestAlertStauts: PropTypes.func,
    getCountries: PropTypes.func,
    getStates: PropTypes.func,
    getAddresses: PropTypes.func,
    getCustomerPaymentMethods: PropTypes.func,
    getPaymentMethods: PropTypes.func,
    processLease: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    i18n: PropTypes.object,
    countries: PropTypes.array,
    states: PropTypes.array,
    isAuthenticated: PropTypes.bool,
    userInfo: PropTypes.object,
    orderSummary: PropTypes.object,
    currentApprovalCode: PropTypes.object,
    config: PropTypes.object,
    history: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        countries: state.countries,
        states: state.states,
        userInfo: state.userInfo,
        orderSummary: state.orderSummary,
        currentApprovalCode: state.currentApprovalCode
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setGuestAlertStauts: setGuestAlertStauts,
        getCountries: getCountries,
        getStates: getStates,
        getAddresses: getAddresses,
        getCustomerPaymentMethods: getCustomerPaymentMethods,
        getPaymentMethods: getPaymentMethods,
        processLease: processLease,
        toggleBlockingStatus: toggleBlockingStatus
    }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProcessLease));
